import React from "react";

import tata1 from "../../Assets/tata/tata1.png";
import tata2 from "../../Assets/tata/tata2.png";
import tata3 from "../../Assets/tata/tata3.png";
import tata4 from "../../Assets/tata/tata4.png";
import tata5 from "../../Assets/tata/tata5.png";
import spotify1 from "../../Assets/spotify/spotify1.png";
import spotify2 from "../../Assets/spotify/spotify2.png";
import spotify3 from "../../Assets/spotify/spotify3.png";
import spotify4 from "../../Assets/spotify/spotify4.png";
import spotify5 from "../../Assets/spotify/spotify5.png";
import spotify6 from "../../Assets/spotify/spotify6.png";
import drivezy1 from "../../Assets/drivezy/drivezy1.png";
import drivezy2 from "../../Assets/drivezy/drivezy2.png";
import drivezy3 from "../../Assets/drivezy/drivezy3.png";
import drivezy4 from "../../Assets/drivezy/drivezy4.png";
import drivezy5 from "../../Assets/drivezy/drivezy5.png";
import drivezy6 from "../../Assets/drivezy/drivezy6.png";
import drivezy7 from "../../Assets/drivezy/drivezy7.png";

import SlideShow from "./SlideShow.jsx";

import "./Project.css";

const tataArray = [tata1, tata2, tata3, tata4, tata5];
const spotifyArray = [
	spotify1,
	spotify2,
	spotify3,
	spotify4,
	spotify5,
	spotify6,
];
const drivezyArray = [
	drivezy1,
	drivezy2,
	drivezy3,
	drivezy4,
	drivezy5,
	drivezy6,
	drivezy7,
];

const Project = () => {
	return (
		<section className="project section" id="project">
			<h2 className="section_title">Projects</h2>
			<span className="section_subtitle">works</span>

			<div className="project_container container">
				<div className="project_item">
					<div className="project_img-div">
						<SlideShow images={tataArray} title="Online pharmacy snapshot" />
					</div>

					<div>
						<h3>Online Pharmacy</h3>
						<p>
							Healthcare E-Pharmacy platform where users can order medicines,
							tablets, other health related products. Ability to search for
							medicines choose between various category. Filter results with
							multiple parameters and sort accordingly. Add to cart and order.
						</p>
						<p className="tech_stack">
							Tech Stack <span>- React, Redux, Node, Express, Mongodb</span>
						</p>

						<div className="project_item-btndiv">
							<a
								href="https://github.com/viz404/Online-Pharmacy-1mg"
								target="_blank"
							>
								<button>Github</button>
							</a>
							<a
								href="https://onemg-express-clone.netlify.app/"
								target="_blank"
							>
								<button>
									Demo <i className="bx bx-right-arrow-alt "></i>
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div className="project_container container">
				<div className="project_item">
					<div className="project_img-div">
						<SlideShow images={spotifyArray} title="Online Music Player" />
					</div>

					<div>
						<h3>Online Music Player</h3>
						<p>
							Multi user music player application with Mobile, Tablet and PC
							Screen responsiveness. Ability to search Songs, Albums, Artists,
							Playlists and play on the go with a built in media player to
							switch between various songs
						</p>
						<p className="tech_stack">
							Tech Stack <span>- JavaScript, HTML, CSS</span>
						</p>

						<div className="project_item-btndiv">
							<a
								href="https://github.com/viz404/Online-Music-Player"
								target="_blank"
							>
								<button>Github</button>
							</a>
							<a
								href="https://spotify-clone-vanilla-js.netlify.app/"
								target="_blank"
							>
								<button>
									Demo <i className="bx bx-right-arrow-alt "></i>
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div className="project_container container">
				<div className="project_item">
					<div className="project_img-div">
						<SlideShow images={drivezyArray} title="Online Vehical Rental" />
					</div>

					<div>
						<h3>Online Vehicle Rental App</h3>
						<p>
							Vehicle rental web application with the ability to perform search,
							select date and time to pick up the vehicle, switch between bike
							and car, search using city. Ability to filter using type of
							vehicle and apply sort.
						</p>
						<p className="tech_stack">
							Tech Stack <span>- JavaScript, HTML, CSS</span>
						</p>

						<div className="project_item-btndiv">
							<a
								href="https://github.com/viz404/Vehicle-Rental-Application"
								target="_blank"
							>
								<button>Github</button>
							</a>
							<a href="https://drivezy-clone.netlify.app/" target="_blank">
								<button>
									Demo <i className="bx bx-right-arrow-alt "></i>
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Project;
